import * as React from "react";
import { loadDemoPlayer, DemoPlayer, DemoVoice } from "./demoAudio";

const BASE = process.env.PUBLIC_URL || "";

// Real, prerendered Soniox clips (generated by scripts/render_experiential_demos.py
// and shipped as static assets). The visitor just plays + remixes them.
const CHAIR: DemoVoice[] = [
  { mode: "punitive_parent", label: "Punitive Parent", line: "You'll fail like you always do.", level: 28, file: `${BASE}/demo/schema-chair/punitive_parent.mp3` },
  { mode: "vulnerable_child", label: "Vulnerable Child", line: "I'm so tired of being scared.", level: 55, file: `${BASE}/demo/schema-chair/vulnerable_child.mp3` },
  { mode: "healthy_adult", label: "Healthy Adult", line: "You're allowed to rest. I've got you.", level: 84, file: `${BASE}/demo/schema-chair/healthy_adult.mp3` },
];

export function ChairDemo() {
  const [loaded, setLoaded] = React.useState(false);
  const [busy, setBusy] = React.useState(false);
  const [err, setErr] = React.useState("");
  const [gains, setGains] = React.useState<number[]>(CHAIR.map((c) => c.level / 100));
  const playerRef = React.useRef<DemoPlayer | null>(null);

  React.useEffect(() => () => playerRef.current?.close(), []);

  const hear = async () => {
    setErr("");
    setBusy(true);
    try {
      if (!playerRef.current) {
        playerRef.current = await loadDemoPlayer(CHAIR);
        gains.forEach((g, i) => playerRef.current!.setGain(i, g));
      }
      await playerRef.current.play();
      setLoaded(true);
    } catch {
      setErr("Audio preview is being prepared.");
    } finally {
      setBusy(false);
    }
  };

  const onGain = (i: number, v: number) => {
    setGains((g) => g.map((x, j) => (j === i ? v : x)));
    playerRef.current?.setGain(i, v);
  };

  return (
    <div className="lib-ex cdemo">
      <span className="lib-ex__label">real studio voices, mix it live</span>
      {CHAIR.map((c, i) => (
        <div key={c.mode} className="cdemo-row">
          <div className="cdemo-row__head">
            <span className="cdemo-row__mode">{c.label}</span>
            <span className="cdemo-row__quote">“{c.line}”</span>
          </div>
          <input
            className="cdemo-row__fader"
            type="range"
            min={0}
            max={1.5}
            step={0.01}
            value={gains[i]}
            disabled={!loaded}
            aria-label={`${c.label} volume`}
            onChange={(e) => onGain(i, parseFloat(e.target.value))}
          />
        </div>
      ))}
      <button type="button" className="cdemo-btn" onClick={hear} disabled={busy}>
        {busy ? "loading…" : loaded ? "▶ play again" : "▶ hear it"}
      </button>
      {err && <span className="cdemo-err">{err}</span>}
    </div>
  );
}
